import React from 'react';
import MatchSlider from './components/MatchSlider/MatchSlider';
import FeaturedArticle from './components/FeaturedArticle';
import LeagueStandingsTable from './components/Table';
import PartnerComponent from './components/Partner';
import { useStandingsFirstLeague, useAllStandingsSecondLeague } from '../../hooks/standingsHooks/useStandingsData';
import { useLeagueSelection } from '../../hooks/useLeagueSelection';
import {useDocumentTitle} from '../../hooks/useDocumentTitle';
import ErrorBoundary from '../../components/ErrorBoundary';
import './HomePage.css';

const HomePage = () => {
  useDocumentTitle('RBA | Home');
  const { leagueLevel } = useLeagueSelection();
  const { data: tableFirstLeague, isLoading: isLoadingTableFirst } = useStandingsFirstLeague();
  const { data: tableSecondLeague, isLoading: isLoadingTables } = useAllStandingsSecondLeague();
  return (
    <div className="home">
      <section className="home__matches">
        <ErrorBoundary>
          <MatchSlider />
        </ErrorBoundary>
      </section>

      <section className="home__featured">
          <section className="home__article-section">
            <ErrorBoundary>
              <FeaturedArticle />
            </ErrorBoundary>
          </section>
          <section className="home__standings">
            <ErrorBoundary>
              {leagueLevel === "1" ?
                  <LeagueStandingsTable
                    title="Tabelle"
                    data={tableFirstLeague?.query}
                    isLoadingTables={isLoadingTableFirst}
                  />
                  :
                  <>
                    <LeagueStandingsTable
                      title="Tabelle Nord/Ost"
                      data={tableSecondLeague?.NO}
                      isLoadingTables={isLoadingTables}
                    />
                    <LeagueStandingsTable
                      title="Tabelle Süd/West"
                      data={tableSecondLeague?.SW}
                      isLoadingTables={isLoadingTables}
                    />
                  </>
              }
            </ErrorBoundary>
          </section>

      </section>
      <section className="home__partner">
        <ErrorBoundary>
          <PartnerComponent />
        </ErrorBoundary>
      </section>
    </div>
  );
};

export default HomePage;
